import * as Sentry from "@sentry/react";

/**
 * Initialise Sentry only when a DSN is configured. Safe no-op otherwise.
 * Env: REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENV, REACT_APP_VERSION.
 */
const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || "production",
    release: process.env.REACT_APP_VERSION,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })],
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_SESSION_RATE || "0"),
    replaysOnErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_ERROR_RATE || "1.0"),
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export const isSentryActive = Boolean(dsn);
export default Sentry;
